export default __webpack_public_path__ + "static/media/1_0100.cd2045cc.webp";